import { makeAutoObservable, reaction } from 'mobx';
import KorToEn from '../../utils/KorToEn';
import { sleep } from '../../utils/Sleep';

class ContentV2Store {
	rootStore;

	content = null;

	objects = [];
	backgroundImages = [];
	backgroundAudios = [];

	sequenceNodes = [];
	sceneNodes = [];
	defaultNodes = [];

	edges = [];

	sequenceIndex = -1;
	sceneIndex = -1;
	defaultIndex = -1;

	conditions = [];

	aruco = null;

	constructor(root) {
		makeAutoObservable(this);
		this.rootStore = root;

		this.objects = [];
		this.backgroundImages = [];
		this.backgroundAudios = [];

		this.sequenceNodes = [];
		this.sceneNodes = [];
		this.defaultNodes = [];

		this.edges = [];

		this.sequenceIndex = -1;
		this.sceneIndex = -1;
		this.defaultIndex = -1;

		this.conditions = [];

		// reaction(
		// 	() => `${this.sequenceIndex}_${this.sceneIndex}_${this.defaultIndex}`,
		// 	() => {
		// 		if (
		// 			this.sequenceIndex !== -1 &&
		// 			this.sceneIndex !== -1 &&
		// 			this.defaultIndex !== -1
		// 		) {
		// 			this.rootStore.playerControlV2Store.likuPlay();
		// 		}
		// 	},
		// );
	}

	init(info, data) {}

	initIndex(value) {
		this.sequenceIndex = value;
		this.sceneIndex = value;
		this.defaultIndex = value;
	}

	setContent(data) {
		this.content = data;
	}

	setObjects(data) {
		this.objects = data;
	}

	setSequenceNodes(nodes) {
		this.sequenceNodes = nodes;
	}

	setSceneNodes(nodes) {
		this.sceneNodes = nodes;
	}

	setDefaultNodes(nodes) {
		this.defaultNodes = nodes;
	}

	setEdges(data) {
		this.edges = data;
	}

	setConditions(data) {
		this.conditions = data;
	}

	getSequenceScenes(sequenceId) {
		let currentSequenceId = sequenceId;
		if (!currentSequenceId) {
			currentSequenceId = this.sequenceNodes[this.sequenceIndex]?.id;
		}
		return this.sceneNodes.filter(
			(node) => node.parentId === currentSequenceId,
		);
	}

	getSceneDefaults(sceneId) {
		let currentSceneId = sceneId;
		if (!currentSceneId) {
			const currentSequenceId = this.sequenceNodes[this.sequenceIndex]?.id;
			currentSceneId = this.sceneNodes.find(
				(node) => node.parentId === currentSequenceId,
			)?.id;
		}
		return this.defaultNodes.filter((node) => node.parentId === currentSceneId);
	}

	getCurrentDefault() {
		const currentScene = this.getSequenceScenes(
			this.sequenceNodes[this.sequenceIndex]?.id,
		)?.[this.sceneIndex];
		const currentDefaults = this.getSceneDefaults(currentScene?.id);
		return currentDefaults?.[this.defaultIndex];
	}

	getCurrentSoundCondition() {
		const curCondition = this.conditions.find(
			(condition) => condition?.type?.toLowerCase() === 'sound',
		);
		return curCondition;
	}

	setSequenceIndex(value) {
		this.sequenceIndex = value;
	}

	setSceneIndex(value = this.sceneIndex + 1) {
		const curScene = this.getSequenceScenes(
			this.sequenceNodes[this.sequenceIndex]?.id,
		)?.[value];
		// const curSceneObjects = curScene?.data?.objects;
		// this.setObjects(curSceneObjects);
		this.sceneIndex = value;
	}

	setDefaultIndex(value = this.defaultIndex + 1) {
		this.defaultIndex = value;
	}

	setBackgroundImages(data) {
		this.backgroundImages = data;
	}

	setBackgroundAudios(data) {
		this.backgroundAudios = data;
	}

	getStartSequence() {
		const startNode = this.content?.flow?.node?.find((n) => n.type === 'start');
		const startEdge = this.edges.find((edge) => edge.source === startNode.id);
		const startSequence = this.sequenceNodes.find(
			(node) => node.id === startEdge.target,
		);
		return startSequence;
	}

	getNextSequences() {
		const outgoingEdges =
			this.edges?.filter((edge) => {
				// 현재 시퀀스 노드의 ID를 소스로 가진 엣지들 필터링
				return edge.source === this.sequenceNodes[this.sequenceIndex]?.id;
			}) || [];
		if (this.sequenceIndex === -1) {
			const startSequence = this.getStartSequence();
			console.log('getNextSequences startSequence', startSequence);
			return {
				sequences: [startSequence],
				edges: outgoingEdges,
			};
		}
		// 현재 시퀀스에서 나가는 엣지들 찾기
		console.log('hasNext outgoingEdges', outgoingEdges);

		// 해당 엣지들의 타겟 노드(다음 시퀀스 노드들) 반환
		return {
			sequences: outgoingEdges
				.map((edge) => {
					return this.sequenceNodes.find((node) => node.id === edge.target);
				})
				.filter((node) => node !== undefined),
			edges: outgoingEdges || [],
		}; // 존재하는 노드만 반환
	}

	async setNextPool() {
		const { sequences: nextSequences, edges: nextEdges } =
			this.getNextSequences();
		console.log('hasNext nextSequences', nextSequences);
		const hasNextSequence = nextSequences?.length > 0;
		const curSequenceScenes = this.getSequenceScenes(
			this.sequenceNodes[this.sequenceIndex]?.id || [],
		);
		const curSequenceSceneIndex = curSequenceScenes.findIndex(
			(node, index) => index === this.sceneIndex,
		);
		const hasNextScene = curSequenceScenes?.length > curSequenceSceneIndex + 1;

		const curSceneDefaults = this.getSceneDefaults(
			curSequenceScenes[this.sceneIndex]?.id || [],
		);
		const curSceneDefaultIndex = curSceneDefaults.findIndex(
			(node, index) => index === this.defaultIndex,
		);
		const hasNextDefault = curSceneDefaults?.length > curSceneDefaultIndex + 1;

		// default, scene, sequence 순으로 검색 >> 다음 진행 노드그룹 포함관계상
		const fitConditionEdges = await this.checkCondition(
			nextEdges,
			curSequenceScenes[this.sceneIndex]?.id,
			hasNextScene,
			hasNextDefault,
		);
		this.setConditions([]);

		if (hasNextDefault) {
			this.setDefaultIndex();
		} else if (hasNextScene) {
			console.log('fitCondition hasNextScene', hasNextScene);
			// 음... 이거 좀 이상함

			const nextSequenceSceneIndex = curSequenceScenes.findIndex(
				(node, index) => index === curSequenceSceneIndex + 1,
			);
			const nextSequenceScene = curSequenceScenes[nextSequenceSceneIndex];
			const nextSceneIndex = curSequenceScenes.findIndex(
				(node) => node.id === nextSequenceScene?.id,
			);
			console.log('nextSceneIndex', nextSceneIndex);
			this.setSceneIndex(nextSceneIndex);
			this.setDefaultIndex(0);
		} else if (hasNextSequence) {
			const sequenceIndex = this.sequenceNodes.findIndex((node) =>
				!fitConditionEdges?.length
					? nextSequences[0]?.id === node.id
					: node.id === fitConditionEdges[0]?.target,
			);

			this.setSequenceIndex(sequenceIndex);
			console.log('nextSequenceIndex', sequenceIndex, nextSequences);
			this.setSceneIndex(0);
			this.setDefaultIndex(0);
		} else {
			this.rootStore.playerControlV2Store.stop();
		}
	}

	async checkCondition(edges, sceneId, hasNextScene, hasNextDefault) {
		console.log('checkCondition', hasNextScene);
		// 조건은 Scene에 존재합니다. default 노드까지 조건을 확인하지는 않기로 했습니다.
		const currentScene = this.sceneNodes.find((node) => node.id === sceneId);
		const sceneObejcts = currentScene?.data?.objects;
		const conditionEdges = edges?.filter((edge) => edge.data?.length) || [];

		// 대기 조건이 있는 엣지 확인
		// const waitEdges = conditionEdges?.filter(
		// 	(edge) => edge.data?.isWait === true || !hasNextScene,
		// );
		const waitEdges = conditionEdges?.filter((edge) => {
			return edge.data?.length > 0 && !hasNextScene && !hasNextDefault;
		});

		if (waitEdges.length > 0) {
			// 대기 조건이 있는 경우 조건이 만족될 때까지 반복 확인
			let conditionMet = false;
			if (!sceneObejcts?.length) {
				console.log(' hasNextDefault 대기 조건 확인 중:', waitEdges[0].data);
				return [waitEdges[0]];
			}
			while (!conditionMet) {
				const isSound = waitEdges.find((edge) =>
					edge.data?.some(
						(condition) => condition.type.toLowerCase() === 'sound',
					),
				);
				if (isSound && !this.rootStore.playerControlV2Store.isSoundMode) {
					await this.setSound();
				} else {
					console.log('checkCondition', waitEdges);
					// 모든 대기 조건 엣지에 대해 확인
					for (const edge of waitEdges) {
						const currentSceneObejcts = sceneObejcts?.filter((object) =>
							edge?.data?.some((condition) => {
								console.log('checkCondition', condition, object);
								return (
									condition.value === object?.uuid &&
									condition?.type?.toLowerCase() ===
										object?.usageType?.toLowerCase()
								);
							}),
						);
						// 여기서 this.conditions 조건과 비교해서 fitObjects 가 있는지 찾아야해

						const fitObjects = this.conditions.filter((condition) =>
							currentSceneObejcts.some((obj) => {
								// 조건 객체의 타입과 값이 모두 일치하는지 확인

								return (
									obj.fileUuid === condition.fileUuid &&
									obj.usageType.toLowerCase() ===
										condition.usageType?.toLowerCase() &&
									obj.uuid === condition.uuid
								);
							}),
						);

						// soundCheck 소리 들으면 0 번째에 조건 넣음
						const soundCheck = edge.data?.find(
							(condition) =>
								condition.type.toLowerCase() === 'sound' &&
								condition.value === this.conditions?.[0]?.value,
						);
						if (isSound && !soundCheck && this.conditions?.[0]?.value) {
							this.rootStore.playerControlV2Store.setIsSoundMode(false);
						}

						if (
							fitObjects.length > 0 ||
							soundCheck ||
							this.sequenceIndex === -1
						) {
							console.log('checkCondition', soundCheck, isSound);
							// 조건 만족
							conditionMet = true;
							return [edge]; // 만족하는 첫 번째 조건 반환
						}
					}

					// 조건이 만족되지 않았으면 잠시 대기 후 다시 확인
					if (!conditionMet) {
						await sleep(500); // 0.5초 대기
					}
				}
			}
		}

		// 일반 조건 처리 (대기 조건이 없거나 대기 조건이 이미 처리된 경우)
		const fitConditions = conditionEdges?.filter((edge) => {
			console.log('checkCondition', edge.data);
			console.log('checkCondition', sceneObejcts);
			const fitObejcts = sceneObejcts?.filter(
				(object) => object?.fileUuid === edge?.data?.value,
			);
			return fitObejcts.length > 0;
		});

		return fitConditions;
	}

	async setSound() {
		if (!this.rootStore.playerControlV2Store.isSoundMode) {
			try {
				console.log('소리조건');
				this.rootStore.playerControlV2Store.setIsSoundMode(true);
				this.rootStore.mqttStore.playerMqtt.setListenText(
					this.rootStore.playerControlV2Store.setSoundInput.bind(this),
				);
				await sleep(500);

				const message = {
					action: {
						action_name: 'None',
						action_type: 'overlap',
						pitch: 0,
						yaw: 0,
					},
					display: {
						display_name: 'None',
						delay: 0,
						playtime: 1,
						playspeed: 1,
					},
					speech: {
						speech_name: 'empty_p1',
						TTS: '',
						delay: 0,
						repeat: 1,
					},
					listen: 'transcript',
				};

				const englishName = KorToEn('리쿠');
				this.rootStore.mqttStore?.playerMqtt.playMotion(
					this.rootStore.playerControlV2Store.executionUuid,
					englishName,
					message,
				);

				return true;
			} catch (e) {
				console.log('setSound Error!!! : ', e);
				return false;
			}
		}
	}

	clear() {
		this.objects = [];

		this.sequenceNodes = [];
		this.sceneNodes = [];
		this.defaultNodes = [];

		this.edges = [];

		this.sequenceIndex = -1;
		this.sceneIndex = -1;
		this.defaultIndex = -1;
	}
}

export default ContentV2Store;
